import { lazy, memo, Suspense } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import LayoutClient from 'src/layouts/layout';
import SpinnerLoader from 'src/libraries/SpinnerLoader';
import RouteGuard from 'src/routes/guard';
import { Routes as Router } from 'src/routes/route';
import InitAppProvider from './initApp.provider';
import NotificationProvider from './notification.provider';

const Page404Screen = lazy(() => import('src/screens/errors/page404'));
const Page500Screen = lazy(() => import('src/screens/errors/page500'));
const Page403Screen = lazy(() => import('src/screens/errors/page403'));

const LoginScreen = lazy(() => import('src/screens/auth/login/index'));

const DashboardScreen = lazy(() => import('src/screens/dashboard'));
const ThemMoiTinTucScreen = lazy(() => import('src/screens/TinTuc/ThemMoi'));
const ChinhSuaTinTucScreen = lazy(() => import('src/screens/TinTuc/ChinhSua'));

const ThongTinCaNhanScreen = lazy(() => import('src/screens/ThongTinCaNhan'));
const ChamCongScreen = lazy(() => import('src/screens/ChamCong'));

const DonNghiPhepScreen = lazy(() => import('src/screens/DonNghiPhep'));
const PheDuyetDonNghiPhepScreen = lazy(() => import('src/screens/DonNghiPhep/PheDuyet'));

function RouteProvider() {
  return (
    <Routes>
      <Route
        element={
          <InitAppProvider>
            <RouteGuard>
              <NotificationProvider>
                <LayoutClient />
              </NotificationProvider>
            </RouteGuard>
          </InitAppProvider>
        }
      >
        <Route path={Router.HOME.path} element={<DashboardScreen />} />
        <Route path={Router.TIN_TUC_THEM_MOI.path} element={<ThemMoiTinTucScreen />} />
        <Route path={Router.TIN_TUC_CHINH_SUA.path} element={<ChinhSuaTinTucScreen />} />
        <Route path={Router.THONG_TIN_CA_NHAN.path} element={<ThongTinCaNhanScreen />} />
        <Route path={Router.CHAM_CONG.path} element={<ChamCongScreen />} />

        <Route path={Router.NGHI_PHEP_DON_CUA_TOI.path} element={<DonNghiPhepScreen />} />
        <Route path={Router.NGHI_PHEP_PHE_DUYET.path} element={<PheDuyetDonNghiPhepScreen />} />
      </Route>

      <Route
        element={
          <Suspense fallback={<SpinnerLoader bg={false} />}>
            <Outlet />
          </Suspense>
        }
      >
        <Route path={Router.LOGIN.path} element={<LoginScreen />} />

        <Route path={Router.PAGE500.path} element={<Page500Screen />} />
        <Route path={Router.PAGE403.path} element={<Page403Screen />} />

        <Route path="*" element={<Page404Screen />} />
      </Route>
    </Routes>
  );
}

export default memo(RouteProvider);
